import React, { forwardRef } from 'react';
import {
    NavigationDropdown,
    NavigationLink,
    NavigationListItem,
} from '@paypoteam/page-components';
import * as Sentry from '@sentry/nextjs';

import { cn } from '@/lib/utils';

import type { NavListProps } from '@/types';

export const DesktopList = forwardRef<HTMLUListElement, NavListProps>(
    ({ links, className, location }, ref) => (
        <ul
            ref={ref}
            className={cn('flex items-center gap-1 p-0', className)}
        >
            {links.map((link, i) =>
                !!link.menu ? (
                    <NavigationDropdown
                        key={`${link.menu.list[0]?.href}_${i}`}
                        data={link}
                        location={location}
                    />
                ) : (
                    <NavigationListItem
                        key={`${link.href}_${i}`}
                        className={
                            link.badge && 'lg:bg-green-100 dark:lg:bg-green-800'
                        }
                    >
                        <NavigationLink
                            linkData={link}
                            variant={
                                location === link.href
                                    ? { color: 'active' }
                                    : { color: 'primary' }
                            }
                            onClick={() => {
                                Sentry.addBreadcrumb({
                                    category: 'navigation',
                                    message:
                                        'click on the menu link ' + link.href,
                                    level: 'info',
                                });
                            }}
                        />
                    </NavigationListItem>
                ),
            )}
        </ul>
    ),
);
